import React from 'react';
import certificateImage from '../assets/IMG_3027.JPG'
import certificateIMG from '../assets/IMG_3029.JPG'
import IckCerf from '../assets/IMG_3054.jpg'

const Knowledge = () => {
  return (
    <section className="container-fluid text-light mt-5 pt-5">
      <div className='knowledge-container'>
         <div className="row">
           <div className="col-lg-6 col-md-6 col-sm-12">
                <h2>My Knowledge</h2>
                <p>During my educational journey, I completed  comprehensive course's
                    at ICK(Innovation Center Of Kosova) and Probit Academy covering web development technologies, including JavaScript,PHP,MySQL,HTML, CSS,Tailwind, and Bootstrap . Through hands-on projects, I gained a solid understanding of each technology's role in web development.
                    <br /> <br />                 
                    By completing this courses, I acquired a comprehensive skill set. Empowering me to design and develop robust and scalable web applications. I am confident in my ability to contribute effectively to web development projects and continuously enhance my skills in this ever-evolving field.
                    <br />
                    <br />
                    Through self-guided learning , I mastered React.js, Next.js, Figma, Redux, Three.js, and API integration. Motivated by curiosity, I immersed myself in online resources, tutorials, and hands-on projects. This independent journey honed my problem-solving skills and deepened my understanding of these technologies. Now, I'm equipped to create captivating web experiences that push boundaries and make a meaningful impact. With a passion for continuous growth, I'm excited to contribute my self-taught skills to innovative projects.
                 </p>
           </div>

           <div className="col-lg-5 col-md-4 col-sm-12 mt-5 gap-5">
             <h1 className='mb-3 ms-5'>Certifications</h1>
             <div class="accordion" id="chapters">
               <div class="accordion-item">
                 <h2 class="accordion-header" id="heading-1">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" 
                     data-bs-target="#chapter-1" aria-expanded="true" aria-controls="chapter-1">
                     Probit Academy Certification</button>
                 </h2>
                 <div id="chapter-1" class="accordion-collapse collapse show" 
                          aria-labelledby="heading-1" data-bs-parent="#chapters">
                   <div class="accordion-body">
                      <img className="img-fluid" src={certificateImage} alt="Certificate" />
                    </div>
                </div>
             </div>

             <div class="accordion-item">
               <h2 class="accordion-header" id="heading-2">
                 <button class="accordion-button" type="button" data-bs-toggle="collapse" 
                 data-bs-target="#chapter-2" aria-expanded="true" aria-controls="chapter-1">
                 AAB College Certification</button>
               </h2>
               <div id="chapter-2" class="accordion-collapse collapse" 
                aria-labelledby="heading-2" data-bs-parent="#chapters">
                 <div class="accordion-body">
                   <img className="img-fluid" src={certificateIMG} alt="Certificate" />
                 </div>
               </div>
             </div>
          

           <div class="accordion-item">
               <h2 class="accordion-header" id="heading-3">
                 <button class="accordion-button" type="button" data-bs-toggle="collapse" 
                 data-bs-target="#chapter-3" aria-expanded="true" aria-controls="chapter-1">
                  ICK Certification</button>
               </h2>
               <div id="chapter-3" class="accordion-collapse collapse" 
                aria-labelledby="heading-3" data-bs-parent="#chapters">
                 <div class="accordion-body">
                   <img className="img-fluid" src={IckCerf} alt="Certificate" />
                 </div>
               </div>
             </div>
          </div>

        </div>
      </div>
    </div>
    </section>
  );
};

export default Knowledge;
